import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import ManagePost from 'modules/posts/components/ManagePost'

const NewKudosPage = () => (
  <ResponsivePage.Body variant="full" showHeader={false}>
    <ManagePost isKudos />
  </ResponsivePage.Body>
)

export default NewKudosPage
